import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import { parseDate } from "../components/forecasts/utils/utilis";

export default {
    async list() {
        // return await http.get(buildUrlFromLocation("/cf/periods", { campaignId: null }));
        return await http.get(buildUrlFromLocation("/cf/periods", { campaignId: null })).then(cfPeriods => {
            for (let i = 0; i < cfPeriods.length; i++) {
                cfPeriods[i].firmorderOpeningDate = parseDate(cfPeriods[i].firmorderOpeningDate);
                cfPeriods[i].firmorderClosingDate = parseDate(cfPeriods[i].firmorderClosingDate);
                cfPeriods[i].forecastOpeningDate = parseDate(cfPeriods[i].forecastOpeningDate);
                cfPeriods[i].forecastClosingDate = parseDate(cfPeriods[i].forecastClosingDate);
                cfPeriods[i].openingDate = parseDate(cfPeriods[i].openingDate);
            }

            return cfPeriods;
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/cfPeriod.js